
const BarCode = ({ codeRef }) => {

    return (<img ref={codeRef} alt='codebar' />)
};

export default BarCode;